
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFA329"}},[_c('path',{attrs:{"d":"M12 24a12.606 12.606 0 01-.653-.018c-4.106-.221-7.889-2.608-9.875-6.23a11.99 11.99 0 01-1.46-6.233L.011 11.5a11.958 11.958 0 012.052-6.219.48.48 0 01.087-.124A12.017 12.017 0 0112 0a12.02 12.02 0 019.838 5.14.493.493 0 01.115.163 11.926 11.926 0 011.804 9.072.503.503 0 01-.492.398.501.501 0 01-.487-.6A10.934 10.934 0 0021.215 6H16.72c.346.95.606 1.929.773 2.916a.501.501 0 01-.986.168A15.7 15.7 0 0015.652 6h-7.32a14.316 14.316 0 00-1.022 5H8.5a.5.5 0 010 1H7.322c.073 1.645.417 3.324 1.025 5H11.5a.5.5 0 010 1H8.744c.711 1.673 1.683 3.351 2.894 4.993a10.865 10.865 0 002.633-.233.503.503 0 01.525.761.5.5 0 01-.315.217c-.813.174-1.647.262-2.478.262H12zm-9.214-6a11.071 11.071 0 007.539 4.873C9.223 21.277 8.334 19.641 7.679 18H2.786zm4.524-1c-.574-1.683-.899-3.362-.968-5H1c0 1.734.417 3.459 1.206 5H7.31zm-.98-6c.037-1.708.357-3.387.952-5H2.785a10.967 10.967 0 00-1.737 5H6.33zm14.148-6a11.07 11.07 0 00-6.499-3.818A16.562 16.562 0 0116.319 5h4.159zm-5.259 0A15.558 15.558 0 0012.5 1.012a10.365 10.365 0 00-.995 0C10.372 2.263 9.456 3.603 8.776 5h6.443zM7.691 5a17.474 17.474 0 012.359-3.823A11.066 11.066 0 003.522 5h4.169z"}}),_c('path',{attrs:{"d":"M16.761 23.13a.996.996 0 01-.894-.553L10.498 11.84a1.001 1.001 0 011.342-1.342l10.737 5.369a.987.987 0 01.501.578.998.998 0 01-.727 1.293l-3.766.849-.848 3.764a1.008 1.008 0 01-.976.779zm-5.37-11.738l5.37 10.737.849-3.763c.084-.374.38-.67.754-.756l3.766-.849-10.739-5.369c.001 0 0 0 0 0z"}})])])
          )
        }
      }
    